import { all, fork, takeLatest, takeLeading } from 'redux-saga/effects';
import { sliceName } from '../redux/loginSlice';
import * as Sagas from './saga';

function* watchFetchLogin() {
    yield takeLatest(`${sliceName}/fetchLogin`, Sagas.fetchLoginSaga);
}

function* watchFetchForgotPassword() {
    yield takeLatest(
        `${sliceName}/fetchForgotPassword`,
        Sagas.fetchForgotPasswordSaga
    );
}

function* watchFetchChangePassword() {
    yield takeLatest(
        `${sliceName}/fetchChangePassword`,
        Sagas.fetchChangePasswordSaga
    );
}

function* watchFetchResetPassword() {
    yield takeLatest(
        `${sliceName}/fetchResetPassword`,
        Sagas.fetchResetPasswordSaga
    );
}

function* watchFetchInitialData() {
    yield takeLeading(
        `${sliceName}/fetchInitialData`,
        Sagas.fetchInitialDataSaga
    );
}

function* watchFetchGoogleLogin() {
    yield takeLatest(
        `${sliceName}/fetchGoogleLogin`,
        Sagas.fetchGoogleLoginSaga
    );
}

function* watchLogout() {
    yield takeLatest(`${sliceName}/logout`, Sagas.logoutSaga);
}

export function* loginSagas() {
    yield all([fork(watchFetchLogin)]);
    yield all([fork(watchFetchForgotPassword)]);
    yield all([fork(watchFetchChangePassword)]);
    yield all([fork(watchFetchResetPassword)]);
    yield all([fork(watchFetchInitialData)]);
    yield all([fork(watchFetchGoogleLogin)]);
    yield all([fork(watchLogout)]);
}
